
export function getLocalStorageList(key, defaultValue = []) {
  try {
    const stored = localStorage.getItem(key);
    if (!stored) return defaultValue;

    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : defaultValue;
  } catch (e) {
    console.error("localStorage parse error:", e);
    return defaultValue;
  }
}